import React, { useEffect, useState } from "react";
import { Alert, Button, Spin, PageHeader, Layout, Space, Result } from "antd";
import { Formik } from "formik";
import { onecodeAPI } from "../AppConfig";
import { createYupSchema } from "./yupSchemaCreator";
import { useCookies } from "react-cookie";
import _ from "lodash";
import * as Yup from "yup";
import uuid from "react-uuid";
import TextInput from "./TextInput";
import { Redirect } from "react-router";
import NotEligible from "./NotEligible";
import { Modal, Row } from "antd";
import { CloseOutlined } from "@ant-design/icons/lib/icons";

// import "antd/es/spin/style/css";

export default function () {
  const [formData, setFormData] = useState([]);
  const [partnerId, setPartnerId] = useState("");
  const [desc, setDesc] = useState("");
  const [loading, setLoading] = useState(true);
  const { Header, Content, Footer } = Layout;
  const [message, setMessage] = useState("");
  const [cookies, setCookie] = useCookies(["partnerId"]);
  const [ocDeviceId, setOcuuid] = useState(uuid());
  const [categoryId, setCategoryId] = useState("");

  const [isModalVisible, setIsModalVisible] = useState(false);

  const [partnerName, setPartnerName] = useState("");

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  let params = new URLSearchParams(window.location.search);

  // console.log(window.location.pathname, "paramsparams");

  let hash = params.get("hash");
  // hash = hash.replaceAll(" ","+")
  // hash = encodeURIComponent(hash);
  let pathName = window.location.pathname;
  let pathNameWithoutSlash = pathName.replace(/\//g, "");
  // let buff = new Buffer(hash, "base64");
  // let base64ToString = JSON.parse(buff.toString());
  useEffect(() => {
    getFormData();
  }, []);

  let urlencode = encodeURIComponent(hash);
  const getFormData = async () => {
    setLoading(true);
    let getFormData = [];
    let response;
    try {
      if (pathNameWithoutSlash == "v2") {
        response = await onecodeAPI.post(`/partnerForm/findByPartner/v2`, {
          hash: urlencode,
        });
      } else {
        response = await onecodeAPI.get(
          `/partnerForm/findByPartner?hash=${hash}`
        );
      }
// console.log("response", response);
      let partnerName = _.get(
        response,
        "data.data.partnerForms[0].partnerName"
      );
      setPartnerName(partnerName);

      // console.log(response.data,"response.data");
      if (
        _.has(response.data, "message") &&
        _.has(response.data, "partnerId")
      ) {
        // console.log(response);
        setMessage(response.data.message);
        setPartnerId(response.data.partnerId);
        setCategoryId(response.data?.partnerCategoryId);
      }

      getFormData = response.data.data.partnerForms;
      setPartnerId(response.data.data.partnerForms[0].partnerId);
      setCategoryId(response.data.data.partnerForms[0]?.partnerCategoryId);
      let description = _.get(
        response,
        "data.data.partnerForms[0].partner.description"
      );
      setDesc(description);
      setFormData(getFormData);
      setLoading(false);
      if (cookies["oc-deviceId"] == undefined) {
        setCookie("oc-deviceId", ocDeviceId, { path: "/" });
      }

      if (_.has(response.data, "data")) {
        getFormData = response.data.data.partnerForms;
        setPartnerId(response.data.data.partnerForms[0].partnerId);
        setCategoryId(response.data.data.partnerForms[0]?.partnerCategoryId);
        let description = _.get(
          response,
          "data.data.partnerForms[0].partner.description"
        );
        setDesc(description);
        setFormData(getFormData);
      }

      setLoading(false);
    } catch (error) {
      console.log('getdata error',error);
      setLoading(false);
    }
  };

  const initialValues = {};
  formData.length &&
    formData[0].ocForm.ocFieldGroups.forEach((page) => {
      page.ocFields.forEach((item) => {
        initialValues[item.id] = "";
      });
    });

  let ocFields = [];
  formData.length &&
    formData[0].ocForm.ocFieldGroups.map((page) => {
      ocFields = ocFields.concat(page.ocFields);
    });

  const yepSchema = ocFields.reduce(createYupSchema, {});
  const validationSchema = Yup.object().shape(yepSchema);

  const onSubmit = async (values, error) => {
    setLoading(true);
    let fieldValues = [];

    _.map(values, (value, key) => {
      let fieldValue = {
        ocFieldId: key,
        value: value,
      };
      fieldValues.push(fieldValue);
    });

    let data = {
      ocPartnerFormId: formData[0].id,
      ocFieldValues: fieldValues,
      deviceId: cookies["oc-deviceId"] || ocDeviceId,
      partnerCategoryId: categoryId,
    };
    let v2Data = {
      ocUserForm: {
        ocPartnerFormId: formData[0].id,
        ocFieldValues: fieldValues,
      },
      deviceId: cookies["oc-deviceId"] || ocDeviceId,
      partnerCategoryId: categoryId,
      hash: urlencode,
      hasOtpCheck: false,
    };
    let res;
    try {
      if (pathNameWithoutSlash == "v2") {
        res = await onecodeAPI.post(`/userForm/addLead/v2`, v2Data);
      } else {
        res = await onecodeAPI.post(
          `/userForm/addLead?hash=${hash}&hasOtpCheck=false`,
          data
        );
      }

      let brandUrl = _.get(res,"data.data.url");
      let leadID = _.get(res, "data.data.userForm.id");


      if (_.get(res, "data.status") == 2021) {
        setIsModalVisible(true);
      }
      else if (brandUrl && !brandUrl.includes("null")) {
        window.location.replace(brandUrl);
      }else{
        alert("Lead Submitted Successfully");
      }
      setLoading(false);
    } catch (err) {
      console.log(err, "err");
      let message = _.get(err, "response.data.message", "Something went wrong");
      let splitErrors = message.split(",");

      let errors = {};
      splitErrors.forEach((id) => {
        errors = { ...errors, [id]: "Details already exist" };
      });

      error.setErrors(errors);
      setLoading(false);
      alert(message);
    }
  };

  const FormData = (formProperties) => {
    let form = [];
    formData.length &&
      formData[0].ocForm.ocFieldGroups.map((page, pageIndex) => {
        page.ocFields.map((e, index) => {
          if (e.type === "text") {
            form.push(<TextInput {...e} key={index} {...formProperties} />);
          }
        });
      });
    return form;
  };

  if (message) {
    return (
      <div style={{ height: "100%" }}>
        {partnerId ? (
          <div
            style={{
              height: "20%",
              justifyContent: "center",
              alignItems: "center",
              flex: 1,
              display: "flex",
              marginTop: 10,
            }}
          >
            <img
              src={
                categoryId
                  ? `https://onecode-asset.s3.ap-south-1.amazonaws.com/${partnerId}_${categoryId}.jpg`
                  : `https://onecode-asset.s3.ap-south-1.amazonaws.com/${partnerId}.jpg`
              }
              style={{ width: "50%", alignItems: "center" }}
            />
          </div>
        ) : (
          <></>
        )}

        <div
          style={{
            height: "80%",
            // marginTop: "50%",
            textAlign: "center",
            justifyContent: "center",
            display: "flex",
            // alignItems: "center",
            fontSize: "25px",
            paddingTop: partnerId ? "100px" : "300px",
          }}
        >
          {message}
        </div>
      </div>
    );
  } else {
    return (
      <Layout className="layout" style={{ backgroundColor: "#ffff" }}>
        <Header style={{ backgroundColor: "#ffff" }}>
          {/* <div className="logo" >
                        <img src = {`https://www.onecode.in/images/logo.png`} style= {{width :100,height : 45,margin: "10px 20px",}}/>
                    </div> */}
          {/* <div
            style={{ float: "right", marginRight: "20px", marginTop: "20px" }}
          >
            <b>Phone No :</b> {base64ToString.phoneNo}
          </div> */}
        </Header>
        <Content>
          {cookies.partnerLeadSubmissionCount &&
          Number(cookies.partnerLeadSubmissionCount) + 1 > 5 ? (
            <Alert message="You cannot access this page!" type="error" />
          ) : (
            <Spin
              spinning={loading}
              style={{
                flex: 1,
                alignContent: "center",
                justifyContent: "center",
              }}
            >
              <div style={{ textAlign: "center" }}>
                {partnerId ? (
                  <img
                    src={
                      categoryId
                        ? `https://onecode-asset.s3.ap-south-1.amazonaws.com/${partnerId}_${categoryId}.jpg`
                        : `https://onecode-asset.s3.ap-south-1.amazonaws.com/${partnerId}.jpg`
                    }
                    style={{ width: "50%", alignItems: "center" }}
                  />
                ) : (
                  <></>
                )}
                <p style={{ fontSize: 12, paddingLeft: 20, paddingRight: 20 }}>
                  {desc}
                </p>
              </div>
              {formData != null && formData.length > 0 ? (
                <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={onSubmit}
                  validateOnBlur={true}
                  validateOnChange={true}
                  enableReinitialize
                >
                  {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    errors,
                    isValid,
                    touched,
                    setValues,
                    setTouched,
                    resetForm,
                  }) => (
                    <div style={{ marginTop: 20, textAlign: "center" }}>
                      <FormData
                        handleChange={handleChange}
                        values={values}
                        handleBlur={handleBlur}
                        errors={errors}
                        touched={touched}
                        setValues={setValues}
                        setTouched={setTouched}
                      />
                      <div style={{ textAlign: "center" }}>
                        <Button
                          style={{
                            minWidth: 250,
                            padding: 8,
                            borderRadius: 5,
                            height: 40,
                            backgroundColor: "#6c63ff",
                            color: "#fff",
                            marginTop: 20,
                            borderColor: "#6c63ff",
                            borderWidth: 1,
                          }}
                          onClick={handleSubmit}
                        >
                          Save & Proceed
                        </Button>
                      </div>
                    </div>
                  )}
                </Formik>
              ) : (
                <Result
                  status="404"
                  title="404"
                  subTitle="Sorry, the page you visited does not exist."
                />
              )}
            </Spin>
          )}
          <Modal
            visible={isModalVisible}
            // width="335px"
            // onCancel={handleCancel}
            footer={null}
            centered={true}
            closable={false}
            keyboard={true}
            mask={true}
            maskClosable={true}
            closeIcon={
              <CloseOutlined
                style={{
                  fontSize: "7px",
                  marginTop: "10px",
                }}
                onOk={handleOk}
                className="modalCloseBtn"
              />
            }
          >
            <NotEligible partnerName={partnerName} />
          </Modal>
        </Content>
      </Layout>
    );
  }
}
